import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import _ from 'lodash';

import config from 'config';

import { connect } from 'react-redux';

import { loadByQuery } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';
import StorySummary from 'modules/News/components/StorySummary';

const REFRESH_INTERVAL_MILLIS = 30000;

// IMPORTANT
// These are the correct sizes for pages but most of the API calls will attempt to
// load this number + 1. This is to check if there are more articles to show
// i.e for the "Show More" button.
const PAGE_SIZE = 4;

require('./MoreNewsList.scss');

@connect(state => ({ morenews: state.common.morenews }))
export default class MoreNewsList extends Component {
  static propTypes = {
    morenews: PropTypes.object.isRequired,
    initialPageSize: PropTypes.number.isRequired,
    basketQuery: PropTypes.object,
    dispatch: PropTypes.func,
    title: PropTypes.string
  };

  constructor(props){
    super(props);

    this.state = {
      displayedArticles: props.initialPageSize,
      showMorePressed: false
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.refreshNews();
  }

  refreshNews() {
    const { basketQuery, morenews, dispatch } = this.props;
    this.timeout = setTimeout(() => {

      if (!morenews[basketQuery.value].loading) {
        dispatch(loadByQuery(basketQuery, this.state.displayedArticles + 1, 0, true))
          .then(articles => {
            loadMediaForArticles(this.context.store.getState(), dispatch, articles.articles);
          })
          .catch(e => {
            if (!config.isProduction) {
              console.error("Error in Live Update", e); // eslint-disable-line no-console
            }
          })
          .then(() => this.refreshNews());
      } else {
        this.refreshNews();
      }
    }, REFRESH_INTERVAL_MILLIS);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  showMore = () => {
    const { basketQuery, dispatch } = this.props;

    this.setState({
      showMorePressed: true
    });

    dispatch(loadByQuery(basketQuery, PAGE_SIZE + 1, this.state.displayedArticles))
      .then(articles => {
        loadMediaForArticles(this.context.store.getState(), dispatch, articles.articles);
      })
      .catch(e => {
        if (!config.isProduction) {
          console.error("Error in Live Update", e); // eslint-disable-line no-console
        }
      })
      .then(() => {
        this.setState({
          showMorePressed: false,
          displayedArticles: this.state.displayedArticles + PAGE_SIZE
        });
      });
  };

  render() {
    const { morenews, basketQuery } = this.props;
    const newsBasketState = morenews[basketQuery.value];

    const {
      loaded,
      articles = [],
      error
    } = newsBasketState;

    if (loaded && articles.length > 0) {
      return this.renderNews(articles);
    }
    else if (error) {
      return this.renderError();
    }
    return this.renderNoNews();
  }

  renderWrapper(component) {
    const {title} = this.props;

    return (
      <div className="news">
        {title && <MetaDataWrapper title={title}/>}
        {component}
      </div>
    )
  }

  renderNews(articles) {

    const newsSummaries = articles.slice(0, this.state.displayedArticles); // Only show as many as we should
    const loadedArticles = articles.length;
    const leadArticle = newsSummaries.slice(0, 1)[0]; // Always at least 1 in this case.
    const secondaryArticles = _.chunk(newsSummaries.slice(1, 5), 2);
    const otherArticles = _.chunk(newsSummaries.slice(5), 2);

    return this.renderWrapper(
      <section className="morenews">
        <div className="lead-article" id="lead-article">
          <StorySummary className="morenews-article" imageType="leadArticle" key={leadArticle.article_reference.id} data={leadArticle} heroArticle={true} />
        </div>

        {!!secondaryArticles.length && secondaryArticles.map((chunk, index) =>
          <ArticleRow className="secondary-articles" imageType="secondaryArticle" key={index} articles={chunk} />
        )}

        {!!otherArticles.length && otherArticles.map((chunk, index) =>
          <ArticleRow className="other-articles" imageType="otherArticle" key={index} articles={chunk} />
        )}

        {loadedArticles > this.state.displayedArticles &&
          <div className="action-links">
            {!this.state.showMorePressed ?
              <button className="section-button large-primary-button" onClick={() => this.showMore()}>Load more news</button>
              :
              <button disabled className="section-button large-primary-button">Loading...</button>}
          </div>
        }
      </section>
    );
  }

  renderNoNews() {
    return this.renderWrapper(
      <p className="morenews-no-news">There are currently no news articles to display here. Please try again later.</p>
    );
  }

  renderError() {
    return this.renderWrapper(
      <p className="morenews-error">There was a problem loading the news articles.</p>
    );
  }
}

function ArticleRow(props) {
  const {
    articles,
    className,
    imageType
  } = props;

  return (
    <div {...{className}}>
    {articles.map(data =>
      <div className="secondary-article" key={data.article_reference.id}>
        <StorySummary
          imageType={imageType}
          data={data}
          className="morenews-article"
        />
      </div>
    )}
    </div>
  );
}

ArticleRow.propTypes = {
  articles: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
  imageType: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./modules/News/components/MoreNewsList.js